module.exports = {
      id: "train-usage",
      viewBox: "0 0 512 387",
      url: __webpack_public_path__ + "images/sprites/transport.svg#train-usage",
      toString: function () {
        return this.url;
      }
    }